
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.657 2.378c-.225-.452-.047-.637.418-.405l16.495 8.248c.457.229.462.617.03.857L3.694 19.914c-.44.246-.65.06-.47-.41l2.913-7.573 9.075-1.296-9.075-1.297-3.48-6.96z"}})])
          )
        }
      }
    